import { render, staticRenderFns } from "./VendorAgreementModal.vue?vue&type=template&id=57a71402&scoped=true&"
import script from "./VendorAgreementModal.vue?vue&type=script&lang=js&"
export * from "./VendorAgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./VendorAgreementModal.vue?vue&type=style&index=0&id=57a71402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a71402",
  null
  
)

export default component.exports